module.exports = __webpack_public_path__ + "static/media/2400.e148bc44.jpg";